<template>
  <div>
    <v-container class="mb-4">
      <v-row>
        <v-col cols="12" sm="8">
          <p>Ofereço frete grátis dependendo do valor comprado *</p>
          <v-radio-group v-model="resposta.frete.ofertaFreteGratis"
                         :error="$v.resposta.frete.ofertaFreteGratis.$error"
                         @change="onChangeOfereceCif"
                         required>
            <v-radio
              label="Sim"
              :value="true"
            />
            <v-radio
              label="Não"
              :value="false"
            />
          </v-radio-group>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <px-input-money
            label="Valor mínimo para frete grátis"
            class="required"
            ref="valorMinimoFreteGratis"
            :disabled="!resposta.frete.ofertaFreteGratis"
            :error="$v.resposta.frete.valorMinimoFreteGratis.$error"
            @blur="$v.resposta.frete.valorMinimoFreteGratis.$touch()"
            v-model="resposta.frete.valorMinimoFreteGratis"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="12" sm="4">
          <px-date-picker label="Validade da cotação"
                          input-class="required"
                          :error="$v.resposta.validade.$error"
                          @blur="$v.resposta.validade.$touch()"
                          v-model="resposta.validade"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <px-select-enum class="required"
                          label="Tipo de frete"
                          :error="$v.resposta.frete.tipoFrete.$error"
                          @blur="$v.resposta.frete.tipoFrete.$touch()"
                          v-model="resposta.frete.tipoFrete"
                          :items="tiposFrete"/>
        </v-col>
        <v-col class="d-flex" cols="12" sm="4">
          <px-input-number label="Prazo de embarque (Dias úteis)"
                           class="required"
                           :error="$v.resposta.frete.prazoEntrega.$error"
                           @blur="$v.resposta.frete.prazoEntrega.$touch()"
                           v-model="resposta.frete.prazoEntrega"/>
        </v-col>
<!--        <v-col class="d-flex" cols="12" sm="3">-->
<!--          <px-input-money-->
<!--            label="Valor do frete"-->
<!--            class="required"-->
<!--            ref="totalTransporte"-->
<!--            :disabled="isFob"-->
<!--            :error="$v.resposta.frete.totalTransporte.$error"-->
<!--            @blur="$v.resposta.frete.totalTransporte.$touch()"-->
<!--            v-model="resposta.frete.totalTransporte"/>-->
<!--        </v-col>-->
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            rows="2"
            v-model="resposta.frete.observacaoFrete"
            label="Observações do frete"
            counter="1500"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            rows="2"
            v-model="resposta.observacao"
            label="Observações gerais"
            counter="1500"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-btn color="primary"
           class="mr-2"
           @click="clickNext">
      Continuar
    </v-btn>
    <v-btn @click="clickPrevious">
      Voltar
    </v-btn>
  </div>
</template>

<script>
import validationMixin from '@/mixins/validation-mixin';
import { required } from 'vuelidate/lib/validators';
import { TipoFrete } from 'px-business-components';

export default {
  mixins: [validationMixin],
  props: {
    resposta: Object,
  },
  data() {
    return {
      tiposFrete: TipoFrete.values,
    };
  },
  computed: {
    isFob() {
      return this.resposta.frete.tipoFrete === TipoFrete.keys.FOB.key;
    },
  },
  methods: {
    clickNext() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('next');
    },
    clickPrevious() {
      this.$emit('previous');
    },
    onChangeOfereceCif() {
      // workaround para zerar v-money
      this.$refs.valorMinimoFreteGratis.$el.getElementsByTagName('input')[0].value = 0;
      this.resposta.frete.valorMinimoFreteGratis = 0;
    },
    // onChangeTipoFrete() {
    //   if (this.isFob) {
    //     // workaround para zerar v-money
    //     this.$refs.totalTransporte.$el.getElementsByTagName('input')[0].value = 0;
    //     this.resposta.frete.totalTransporte = 0;
    //   }
    // },
  },
  validations() {
    const base = {
      resposta: {
        validade: {
          required,
        },
        frete: {
          tipoFrete: {
            required,
          },
          prazoEntrega: {
            required,
          },
          valorMinimoFreteGratis: {
            required,
          },
          ofertaFreteGratis: {
            required,
          },
        },
      },
    };
    if (this.resposta.frete.ofertaFreteGratis) {
      base.resposta.frete.valorMinimoFreteGratis.minValue = (value) => value > 0;
    }
    return base;
  },
};
</script>
